// extracted by mini-css-extract-plugin
export default {"diff":"amountLabel_diff__zhnor","positive":"amountLabel_positive__xZIlw","negative":"amountLabel_negative__Ck0oi"};